// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-329ee926] {\n  overflow-y: auto;\n}", "",{"version":3,"sources":["webpack://./resources/js/modules/delta-logs/components/ShowDeltaLogs.vue"],"names":[],"mappings":"AACA;EACI,gBAAA;AAAJ","sourcesContent":["\n.scroll {\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
